<template>
    <div class="lezhi-project4">
        <headerBlack-view></headerBlack-view>
        <div class="wrapper ">
            <div class="introduce_wrap flex-layout main">
                <div class="introduce_left">
                    <div class="title flex-layout">
                        <img src="@/assets/yunqiao/menu.png" />
                        <div class="">
                            <h2 class="f28">项目介绍</h2>
                            <img src="@/assets/yunqiao/introduce.png" />
                        </div>
                    </div>
                    <div class="introduce_name">教师信息化水平提升</div>
                    <div class="introduce_detail">
                      遴选项目校，依据项目地区一线教师对当前专业成长提升现状的需求， 结合理论与实际的原则对一线教师、师范生助教进行系统培训，并通过新型的“互联网+新 学生”关系模型建立交流通道，使理论与实际完美结合，陪伴式培训让一线教师、师范 生助教共同成长。
                    </div>
                </div>
                <div class="introduce_right flex-layout ">
                    <div class="introduce_item flex-column-center">
                        <img src="@/assets/yunqiao/teacher/01.png" />
                        <h3>新型的关系模型</h3>
                        <span>New Relational Model</span>
                    </div>
                    <div class="introduce_item flex-column-center">
                        <img src="@/assets/yunqiao/teacher/02.png" />
                        <h3>陪伴式培训输出</h3>
                        <span style="margin-right: -4px;">Accompanying Training</span>
                    </div>
                    <div class="introduce_item flex-column-center">
                        <img src="@/assets/yunqiao/teacher/03.png" />
                        <h3>共同成长</h3>
                        <span>Grow Together</span>
                    </div>
                </div>
            </div>    
            <div class="features-wrap">
                <div class="main">
                    <div class="title flex-layout">
                        <img src="@/assets/yunqiao/menu_white.png" />
                        <div class="">
                            <h2 class="f28" style="color:white">产品特点</h2>
                            <img src="@/assets/yunqiao/feature.png" />
                        </div>
                    </div>
                    <div class="features-items flex-align-between">
                        <div class="item">
                            <img src="@/assets/yunqiao/teacher/icon01.png" alt="">
                            <h3>资源精确输出</h3>
                            <p>为项目地区教师提供优质培<br>训提升教师能力</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/yunqiao/teacher/icon02.png" alt="">
                            <h3>专家助教团队</h3>
                            <p>首都师范大学输出专业导师团<br>队、师范生助教团队</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/yunqiao/teacher/icon03.png" alt="">
                            <h3>陪伴式成长</h3>
                            <p>为项目地区一线教师提供陪<br>伴式培训课程，与项目地区<br>一线教师互助成长</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="architecture-wrap">
                <div class="main">
                    <div class="title flex-layout">
                        <img src="@/assets/yunqiao/menu.png" />
                        <div class="">
                            <h2 class="f28">架构形式</h2>
                            <img src="@/assets/yunqiao/architecture.png"/>
                        </div>
                    </div>
                    <div class="contariner flex-align-around">
                       <img src="@/assets/yunqiao/teacher/09.png" alt="">
                       <div class="section">
                           <div class="item">
                               <h3>核心</h3>
                               <p>
                                以提升教师信息化水平为核心，建立全新的关系模型为基础，解决项目地区一线教师对专业成长环境不理想的实际需求。
                            </p>
                           </div>
                           <div class="item">
                               <h3>关系模型</h3>
                               <p>
                                以提升教师信息化水平为核心，建立全新的关系模型为基础，解决项目地区一线教师对专业成长环境不理想的实际需求。
                            </p>
                           </div>
                           <div class="item">
                               <h3>一线教师/师范生助教</h3>
                               <p>
                                通过项目培训提升一线教师专业能力成长的同时，提升师范生助教能力，为教育事业培养更多的新生力量。
                            </p>
                           </div>
                           <div class="item">
                               <h3>陪伴式/互助式</h3>
                               <p>
                                通过陪伴式和互助式两种方式帮助一线教师、师范生助教共同成长。
                                 </p>
                           </div>
                       </div>
                    </div>
                </div>
            </div>
            <div class="win-wrap-model-one">
                <div class="main">
                    <div class="title flex-layout">
                        <img src="@/assets/yunqiao/menu.png" />
                        <div class="">
                            <h2 class="f28">合作共赢</h2>
                            <img src="@/assets/yunqiao/win2.png" />
                        </div>
                    </div>
                    <div class="container flex-layout">
                        <div class="right-box flex-layout">
                             <div class="img-wrap">
                                <img src="@/assets/yunqiao/teacher/05.png" alt="">
                                <span>专业课程提升</span>
                            </div>
                            <div class="img-wrap">
                                <img src="@/assets/yunqiao/teacher/06.png" alt="">
                                <span>互助式提升</span>
                            </div>
                            <div class="img-wrap">
                                <img src="@/assets/yunqiao/teacher/07.png" alt="">
                                <span>新型的关系模型</span>
                            </div>
                            <div class="img-wrap">
                                 <img src="@/assets/yunqiao/teacher/08.png" alt="">
                                 <span>成果数据</span>
                            </div>
                        </div>
                        <div class="left-img">
                            <img src="@/assets/yunqiao/teacher/04.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-view></footer-view>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>

<style lang="less" scoped>
    @import "./less/lezhi_common.less";
 
 .lezhi-project4 {
    background-color: #FFFFFF;
    
    .features-wrap {
        min-width: 1280px !important;
        max-width: 1920px;
        
        background-image:url("../../assets/yunqiao/teacher/bg.png");
        background-repeat: no-repeat;
        background-size: 101%;
        background-position: 50% 0 ;
    
        .features-items {
            flex-flow: row wrap;
            align-content: flex-start;
            
            margin: 90px auto 160px;
            max-width: 1100px;
            text-align: center;

            .item {
                flex: 0 0 33.33%;
                

                color: #fff;

                img {
                    margin-bottom: 25px;
                }

                h3 {
                    margin-bottom: 25px;

                    font-weight: bold;
                    font-size: 20px;
                }
                p {
                    min-height: 96px;
                    line-height: 32px;

                    font-size: 16px;
                }

            }
        }
    }

    .architecture-wrap {
        padding-top: 30px;
        
        .contariner{
            margin-top: 80px;
            margin-bottom: 60px;
        }
        .section {
            
            h3 {
                font-size:24px;
                font-weight:bold;
                color:#000;
                margin-bottom: 14px;
                margin-top: 32px;
                position: relative;

                &::before {
                    content: " ";
                    position: absolute;
                    top: -32px;
                    left: -25px;
                    width: 35px;
                    height: 49px;
                    background-image: url("../../assets/yunqiao/teacher/icon04.png");
                    background-repeat: no-repeat;
                }
            }

            .item {
                margin-bottom: 50px;

                &:nth-child(2) h3::before {
                    background-image: url("../../assets/yunqiao/teacher/icon05.png");
                }
                &:nth-child(3) h3::before {
                    background-image: url("../../assets/yunqiao/teacher/icon06.png");
                }
                &:nth-child(4) h3::before {
                    background-image: url("../../assets/yunqiao/teacher/icon07.png");
                }
            }

            p {
                font-size: 15px;
                color:#000;
                max-width: 531px;
            }
        }

        
    }

    .win-wrap-model-one {
        background-color: #FFFFFF;

        .left-img::after{
            content: '首都师范大学导师团队';
        }
    }

}
</style>